import { baseUniDriverFactory } from '../utils/test-utils/unidriver';
import { listItemSelectDriverFactory } from '../ListItemSelect/ListItemSelect.uni.driver';
import { UniDriver } from '@wix/unidriver-core';

export const addressInputItemDriverFactory = (base: UniDriver) => {
  return {
    ...baseUniDriverFactory(base),

    /** Get prefix */
    getPrefix: async () => await listItemSelectDriverFactory(base).getPrefix(),

    /** Get main label Text */
    getMainLabelText: async () =>
      await listItemSelectDriverFactory(base).getTitle(),

    /** Get secondary label Text */
    getSecondaryLabelText: async () =>
      await listItemSelectDriverFactory(base).getSubtitle(),

    /** Get suffix */
    getSuffix: async () =>
      await (await listItemSelectDriverFactory(base)).getSuffix(),
  };
};

export type AddressInputItemUniDriver = ReturnType<
  typeof addressInputItemDriverFactory
>;
